import React from 'react';
import Badge from 'react-bootstrap/Badge';
import Modal from 'react-bootstrap/Modal';
import ActivityPage from './ActivityPage';
import RecordPane from './RecordPane';
import SearchPane from './SearchPane';
import { HeartFillIcon, XLgIcon } from './Icons';

function RecordPage(props) {
    const [getItemsPerPage, setItemsPerPage] = React.useState(50);
    const [getPage, setPage] = React.useState(1);
    const [getFilterSearch, setFilterSearch] = React.useState(false);
    const [getLocalSearch, setLocalSearch] = React.useState([]);
    const [getLocalSearchText, setLocalSearchText] = React.useState("");
    const [getModalShow, setModalShow] = React.useState(false);
    const [getActivityModal, setActivityModal] = React.useState(null);

    const clickItemsPerPage = (e, num) => {
        setItemsPerPage(num);
        setPage(1);
    }

    const clickPage = (e, id) => {
        let element = document.getElementById("top");
        element.scrollIntoView({block: "start"});
        setPage(id);
        setModalShow(false);
    }

    const clickFilterSearch = (e) => {
        setFilterSearch(getFilterSearch ? false : true);
    }

    const updateSearchResults = (searchText, results) => {
        setLocalSearchText(searchText);
        setLocalSearch(results);
        setFilterSearch(true);
    }

    const clickTop = () => {
        let element = document.getElementById("top");
        element.scrollIntoView({block: "start"});
    }

    const clickNext = () => {
        setPage(getPage + 1);
        let element = document.getElementById("top");
        element.scrollIntoView({block: "start"});
    }

    const clickPrev = () => {
        setPage(Math.max(getPage - 1, 1));
        let element = document.getElementById("top");
        element.scrollIntoView({block: "start"});
    }

    const clickShowActivity = (actId) => {
        setActivityModal(actId);
    }

    let records = [];
    let searchFound = 0;
    for (let n in props.Records) {
        if (n === "meta") {
            continue;
        }

        let id = props.Records[n];

        let found = false;
        if (getLocalSearch.length > 0)
        {
            found = getLocalSearch.find((rec) => rec === id);
        }
        else
        {
            found = props.SearchRecords.find((rec) => rec === id);
        }

        if (found) {
            searchFound++;
        }

        if (getFilterSearch) {
            if (found) {
                records.push(id);
            }
        }
        else {
            records.push(id);
        }
    }

    let pgs = 1 + Math.trunc(records.length / getItemsPerPage);

    if (getPage > pgs) {
        setPage(1);
    }

    let pages = [];

    if (props.Status) {
        pages.push(<div key={pages.length}>
            {props.Status}
        </div>)
    }

    let modalPages = [];
    for (let i = 1; i <= pgs; i++) {
        let hasFav = false;

        let pageStart = (i-1)*getItemsPerPage;
        for (let n = 0; n < getItemsPerPage; n++)
        {
            let r = props.Records[pageStart + n];
            if (props.Favorite[r])
            {
                hasFav = true;
                break;
            }
        }

        modalPages.push(
            <Badge key={modalPages.length} 
                className="btn mr-1"
                pill={true} 
                onClick={ (e) => { clickPage(e,i) }}>
                {i} {hasFav?<HeartFillIcon />:""}
            </Badge>
        );
    }

    pages.push(
        <Modal key={pages.length} show={getModalShow} onHide={() => {setModalShow(false)}}>
            <Modal.Body>
                {modalPages}
            </Modal.Body>
        </Modal>
    )

    if (getActivityModal)
    {
        pages.push(
            <Modal key={pages.length} className="modal-xl" show={true}>
                <Modal.Header>
                    <h4>ActivytId: {getActivityModal}</h4>
                    <span className="clickable" onClick={() => {setActivityModal(null)}}><XLgIcon /></span>
                </Modal.Header>
                <Modal.Body>
                    <ActivityPage
                        Index={props.Index}
                        ActivityId={getActivityModal}
                        Favorite={props.Favorite}
                        UpdateFavorite={props.UpdateFavorite}
                        >
                    </ActivityPage>
                </Modal.Body>
            </Modal>
        )
    }

    pages.push(
        <div key={pages.length}>
            <Badge className="btn mr-1" 
                bg={getFilterSearch?"info":"secondary"} 
                onClick={clickFilterSearch}>
                Search {searchFound}: {getFilterSearch ? "On" : "Off" }
                </Badge>
            <SearchPane
                Index={props.Index}
                Records={props.Records}
                SearchText={getLocalSearchText}
                UpdateSearchResults={updateSearchResults}
            />
        </div>
    );

    pages.push(
        <div key={pages.length}>
            <Badge className="btn mr-1" bg="success" onClick={clickPrev}>Prev</Badge>
            <Badge className="btn mr-1" pill={true} onClick={clickTop}>{getPage}</Badge>
            <Badge className="btn mr-1" bg="secondary" onClick={()=>{setModalShow(true)}}>/ {pgs}</Badge>
            <Badge className="btn mr-1" bg="success" onClick={clickNext}>Next</Badge>
            <span style={{ marginLeft: "20px" }}></span>
            <Badge className="btn mr-1" bg={getItemsPerPage === 10 ? "success" : "secondary"} onClick={(e) => clickItemsPerPage(e, 10)}>10/pg</Badge>
            <Badge className="btn mr-1" bg={getItemsPerPage === 50 ? "success" : "secondary"} onClick={(e) => clickItemsPerPage(e, 50)}>50/pg</Badge>
            <Badge className="btn mr-1" bg={getItemsPerPage === 100 ? "success" : "secondary"} onClick={(e) => clickItemsPerPage(e, 100)}>100/pg</Badge>
        </div>
    );

    pages.push(<hr key={pages.length}></hr>);

    let items = [];

    items.push(<div key={items.length} id="top"></div>);

    let start = (getPage - 1) * getItemsPerPage;
    for (let i = 0; i < getItemsPerPage; i++) {
        let pos = start + i;
        if (pos < records.length) {
            items.push(<RecordPane
                key={items.length}
                Index={props.Index}
                RecIndex={records[pos]}
                Favorite={props.Favorite}
                UpdateFavorite={props.UpdateFavorite}
                UpdateActivity={clickShowActivity}
            ></RecordPane>);
        }
    }

    let topHeight = 100;

    return <div>
        <div className="mb-4" style={{ height: topHeight+"px" }}>
            {pages}
        </div>
        <div className="scrollable" style={{ height: (window.innerHeight - topHeight - 60)+"px" }}>
            {items}
        </div>
    </div>;
}

export default RecordPage;
